import { categoryLabel, statusLabel, type DamageCategory, type DamageStatus } from '@fsv/core';
import './Status.css';

/**
 * Status is coded by colour AND shape, so it survives colour blindness and
 * glare: gemeldet = hollow ring (not confirmed yet), bekannt = solid dot,
 * beobachtung = dot with an "eye", Reparatur geplant = square, akzeptiert =
 * dot with a level bar ("bleibt so"), behoben = faded dot with a tick,
 * verworfen = crossed ring.
 */
export function StatusGlyph({ status, size = 14 }: { status: DamageStatus; size?: number }) {
  return <span className={`glyph st--${status}`} style={{ width: size, height: size }} aria-hidden="true" />;
}

export function StatusBadge({ status, large = false }: { status: DamageStatus; large?: boolean }) {
  return (
    <span className={`badge st--${status}${large ? ' badge--large' : ''}`}>
      <StatusGlyph status={status} size={large ? 14 : 11} />
      {statusLabel[status]}
    </span>
  );
}

export function CategoryTag({ category }: { category: DamageCategory }) {
  return <span className="tag">{categoryLabel[category]}</span>;
}
